import { render } from "./AudienceCloneForm.vue?vue&type=template&id=2abb05c6"
import script from "./AudienceCloneForm.vue?vue&type=script&lang=js"
export * from "./AudienceCloneForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__